import { productTypes } from "@shared/constants/productTypes";
import { type TProductType } from "@shared/types/product.types";

export const digitalProducts: TProductType[] = [
  productTypes.coop,
  productTypes.futurePow,
  productTypes.prenup,
  productTypes.undividedEstateAgreement,
  productTypes.will,
];
